<template>
  <div class="date-panel-layout">
    <Header type='home-header'/>

    <div v-show="showMenu" class="layer" @click="toggleShowMenu"></div>
    <el-row class="tac data-panel-wrap">
      <el-col :span="4" class="menu" :class="{show: showMenu}">
        <h5 class="panel-wrap">{{ $t('menu.dataPanel')}}</h5>
        <el-menu
          :default-openeds="defaultOption"
          class="bonus-menu"
          background-color="#0A0E22"
          active-text-color="#fff"
          text-color="#989AA2"
          router="router">
          <!-- 数据面板 -->
          <el-menu-item index="0" route="/" class="home-page-wrap" v-bind:class="{ isActive: (thisPath === '/') }">
            <img class="menu-icon home-icon" src="../../assets/menu/homeIcon.png">
            <span slot="title">{{ $t('menu.dataPanel')}}</span>
          </el-menu-item>
          <!-- 轻节点 -->
           <el-submenu index="1">
            <template slot="title">
              <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/liteNode.png">
              <span>{{ $t('menu.liteNode')}}</span>
            </template>
            <!-- <el-submenu index="1-1">
              <template slot="title">选项4</template>
              <el-menu-item index="1-4-1">选项1</el-menu-item>
            </el-submenu> -->
            <!-- 收益详情 -->
            <el-submenu index="1-1">
              <template slot="title">
                <div v-bind:class="{ revenuePad: true }">
                  <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/totalRevenue.png">
                  <span>{{ $t('menu.revenueDetails')}}</span>
                </div>
              </template>
              <!-- 收益总览 -->
              <el-menu-item index="1-1-1" route="/revenue" v-bind:class="{ isActive: (thisPath === '/revenue') }">{{
                $t('menu.revenueOverview') }}
              </el-menu-item>
              <!-- 设备收益详情 -->
              <el-menu-item index="1-1-2" route="/devAllRevenue" v-bind:class="{ isActive: (thisPath === '/devAllRevenue') }">{{
                $t('menu.devTotalRevenue') }}
              </el-menu-item>
              <!-- 网络任务收益详情 -->
              <el-menu-item index="1-1-3" route="/netDetail" v-bind:class="{ isActive: (thisPath === '/netDetail') }">{{
                $t('menu.netRevenueDetails') }}
              </el-menu-item>
              <!-- 计算任务收益详情 -->
              <el-menu-item index="1-1-4" route="/calculateDetail" v-bind:class="{ isActive: (thisPath === '/calculateDetail') }">{{$t('menu.calRevenueDetails') }}
              </el-menu-item>
              <!-- 邀请奖励 -->
             <!-- <el-menu-item index="1-1-5" route="/inviteDetail" v-bind:class="{ isActive: (thisPath === '/inviteDetail') }">{{$t('menu.inviteDetail') }}
              </el-menu-item> -->
               <el-submenu index="1-1-6">
                  <template slot="title">
                    <div v-bind:class="{ revenuePad: true }">
                      <img
                        class="menu-icon home-icon total-revenue-icon"
                        src="../../assets/menu/newAndold.png"
                      >
                      <span>{{$t('menu.activityDetail') }}</span>
                    </div>
                  </template>
                  <el-menu-item
                    index="1-1-6-1"
                    route="/devAllRevenue_new"
                    v-bind:class="{ isActive: (thisPath === '/devAllRevenue_new') }"
                  >{{ $t('menu.newDeviceTotalRevenu')}}
                  </el-menu-item>
                  <el-menu-item
                    index="1-1-6-2"
                    route="/devAllRevenue_old"
                    v-bind:class="{ isActive: (thisPath === '/devAllRevenue_old') }"
                  >{{ $t('menu.oldDeviceTotalRevenu')}}
                  </el-menu-item>
                </el-submenu>
            </el-submenu>
            <el-submenu index="1-2">
              <template slot="title">
                <div v-bind:class="{ revenuePad: true }">
                  <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/network.png">
                  <span>{{ $t('menu.taskStatus')}}</span>
                </div>
              </template>
              <!-- 设备总览 -->
              <el-menu-item index="2-1" route="/deviceOverview" v-bind:class="{ isActive: (thisPath === '/deviceOverview') }">{{$t('menu.deviceOverview') }}
              </el-menu-item>
              <!-- 网络任务运行状态 -->
              <el-menu-item index="2-2" route="/netStatus" v-bind:class="{ isActive: (thisPath === '/netStatus') }">{{$t('menu.networkTaskStatus') }}
              </el-menu-item>
              <!-- 计算任务运行状态 -->
              <el-menu-item index="2-3" route="/calculateStatus" v-bind:class="{ isActive: (thisPath === '/calculateStatus') }">{{$t('menu.calTaskStatus') }}
              </el-menu-item>
              <!-- 计算任务选择 -->
              <el-menu-item index="2-4" route="/calculateTask" v-bind:class="{ isActive: (thisPath === '/calculateTask') }">{{$t('menu.calTask') }}
              </el-menu-item>
               <!-- 小节点故障设备查询 -->
              <el-menu-item index="2-5" route="/standardDevErr" v-bind:class="{ isActive: (thisPath === '/standardDevErr') }">{{ $t('menu.faultDevice') }}
              </el-menu-item>
            </el-submenu>
          </el-submenu>
          <!-- 标准节点-->
          <el-submenu v-if="isZnWebsite" index="9" class="revenue-wrap">
            <template slot="title">
              <div v-bind:class="{ revenuePad: true }">
                <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/standNode.png">
                <span>{{$t('menu.standardNode')}}</span>
              </div>
            </template>
            <el-menu-item-group :span="1">
              <!-- 节点运行状态 -->
              <el-menu-item index="9-1" route="/standardStatus" v-bind:class="{ isActive: (thisPath === '/standardStatus') }">
              {{$t('menu.nodeRunStatus') }}
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group :span="2">
              <!-- 监控 -->
              <el-menu-item index="9-2" route="/standardWatch" v-bind:class="{ isActive: (thisPath === '/standardWatch') }">
              {{$t('watch') }}
              </el-menu-item>
            </el-menu-item-group>
              <!-- 监控（下行） -->
            <el-menu-item-group :span="2">
              <el-menu-item index="9-2" v-if="isDownlinkUser" route="/standardWatchDownlink" v-bind:class="{ isActive: (thisPath === '/standardWatchDownlink') }">
              监控（下行）
              </el-menu-item>
            </el-menu-item-group>
            <!-- 标准节点故障查询 -->
            <el-submenu index="9-1">
              <template slot="title">
                <div v-bind:class="{ revenuePad: true }"  style="padding-left: 40px !important;">
                  <!-- <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/totalRevenue.png"> -->
                  <span>故障查询</span>
                </div>
              </template>
              <el-menu-item-group :span="2">
                <el-menu-item index="9-3" route="/standardDevErrnor" v-bind:class="{ isActive: (thisPath === '/standardDevErrnor') }">{{ $t('menu.faultDevice') }}</el-menu-item>
              </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group :span="1">
                <el-menu-item index="9-3" route="/standardAbnormalDisk" v-bind:class="{ isActive: (thisPath === '/standardAbnormalDisk') }">设备坏盘查询</el-menu-item>
              </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
           <!-- <el-menu-item-group :span="3">
               <el-menu-item index="9-3" route="/standardDevErrnor" v-bind:class="{ isActive: (thisPath === '/standardDevErrnor') }">{{ $t('menu.faultDevice') }}</el-menu-item>
             </el-menu-item-group> -->
             <!-- 业务验收结果 -->
             <el-menu-item-group :span="3">
                 <el-menu-item index="9-3" route="/standardAcceptance" v-bind:class="{ isActive: (thisPath === '/standardAcceptance') }">{{$t('menu.taskAcceptanceRes')}}</el-menu-item>
            </el-menu-item-group>
             <!-- 设备账单详情 -->
             <el-menu-item-group :span="4">
                <el-menu-item index="9-4" route="/standardBill" v-bind:class="{ isActive: (thisPath === '/standardBill') }">{{ $t('menu.billingDetails') }}</el-menu-item>
              </el-menu-item-group>
          </el-submenu>
          <!-- 软路由-->
          <el-submenu v-if="isZnWebsite" index="6" class="revenue-wrap">
            <template slot="title">
              <div v-bind:class="{ revenuePad: true }">
                <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/dialStatus.png">
                <span>软路由</span>
              </div>
            </template>
            <el-menu-item-group :span="2">
              <!-- 拨号状态 -->
              <el-menu-item index="2-1" route="/dialStatus" v-bind:class="{ isActive: (thisPath === '/dialStatus') }">拨号状态
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 自动选择业务 -->
          <el-submenu v-if="isZnWebsite" index="10" class="revenue-wrap">
            <template slot="title">
              <div v-bind:class="{ revenuePad: true }">
                <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/matchTask.png">
                <span>{{$t('menu.chooseBusiness')}}</span>
              </div>
            </template>
            <el-menu-item-group :span="2">
              <!-- 资源详情 -->
              <el-menu-item index="10-1" route="/gapDetails" v-bind:class="{ isActive: (thisPath === '/gapDetails') }">
              {{$t('menu.ResourceDetails') }}
              </el-menu-item>
            </el-menu-item-group>
              <!-- 推荐任务 -->
            <el-menu-item-group :span="3">
              <el-menu-item index="10-2" route="/matchTask" v-bind:class="{ isActive: (thisPath === '/matchTask') }">
                {{$t('menu.matchResources') }}
                </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 提现 -->
          <el-menu-item index="4" v-if="!isZnWebsite" route="/withdrawal" v-bind:class="{ isActive: ifWithdrawal }">
            <img class="menu-icon home-icon" src="../../assets/menu/withdrawal.png">
            <span slot="title">{{ $t('menu.withdrawal') }}</span>
          </el-menu-item>
          <!-- 京东卡兑换 -->
          <el-menu-item index="4" v-if="isZnWebsite" route="/exchange" v-bind:class="{ isActive: ifExchange }">
            <img class="menu-icon home-icon" src="../../assets/menu/withdrawal.png">
            <span slot="title">{{ $t('menu.exchange') }}</span>
          </el-menu-item>
          <!-- 回购 -->
          <!-- <el-menu-item index="7" v-if="auth" route="/buyback" v-bind:class="{ isActive: ifBuyback }"> -->
          <el-menu-item index="8" v-if="isZnWebsite" route="/buyback" v-bind:class="{ isActive: ifBuyback }">
            <img class="menu-icon home-icon" src="../../assets/menu/withdrawal.png">
            <span slot="title">{{ $t('menu.buyBack') }}</span>
          </el-menu-item>
          <!-- 回购95折 -->
          <el-menu-item index="9" v-if="isZnWebsite && auth" route="/buyBackSecond" v-bind:class="{ isActive: ifBuybackSecond }">
            <img class="menu-icon home-icon" src="../../assets/menu/withdrawal.png">
            <span slot="title">{{ $t('menu.buyBackSecond') }}</span>
          </el-menu-item>
          <!-- 全网贡献 -->
          <el-menu-item index="5" route="/networkContribution" v-bind:class="{ isActive: (thisPath === '/networkContribution') }">
            <img class="menu-icon home-icon" src="../../assets/menu/networkCbt.png">
            <span slot="title">{{ $t('menu.netContribution') }}</span>
          </el-menu-item>
          <el-menu-item index="7" disabled>
            <img class="menu-icon home-icon" src="../../assets/menu/powerAnalysis.png">
            <span slot="title">{{ $t('menu.powerAnalysis') }}</span>
          </el-menu-item>
          <!-- <el-menu-item class="menu-item-wrapper" index="7">
            <div v-if="!whichLanguage && type !== 'protocol-header'" class="header-language header-each-tab  bonus-cursor lang" @click="changeLanguage('zn')">
              <img class="menu-icon home-icon" src="../../assets/menu/networkCbt.png">
              中文
            </div>
            <div v-if="whichLanguage && type !== 'protocol-header'" class="header-language header-each-tab  bonus-cursor lang" @click="changeLanguage('en')">English
            </div>
          </el-menu-item> -->
        </el-menu>
        <!-- 移动端展示账号设置 -->
        <h5 class="panel-wrap mobile-account-menus" :class="{none: !showMenu}">{{$t('account_set_menu')}}</h5>
        <el-menu class="bonus-menu" :class="{none: !showMenu}" background-color="#0A0E22" text-color="#989AA2" active-text-color="#fff" router="router">
        <!-- 钱包绑定 -->
        <!-- <el-menu-item index="2" route="/bindWallet" v-bind:class="{ isActive: (thisPath === '/bindWallet') }">
          <img class="menu-icon home-icon" src="../../assets/accountSet/walletBind.png">
          <span slot="title">{{$t('account_set_2')}}</span>
        </el-menu-item> -->
        <el-menu-item index="1" route="/accountSet" class="home-page-wrap" v-bind:class="{ isActive: (thisPath === '/accountSet') }">
          <img class="menu-icon home-icon" src="../../assets/accountSet/accountSet.png">
          <span slot="title">{{$t('account_set_1')}}</span>
        </el-menu-item>
        <el-menu-item v-if="isZnWebsite" index="1" route="/contact" class="home-page-wrap" v-bind:class="{ isActive: (thisPath === '/contact') }">
          <img class="menu-icon home-icon" src="../../assets/accountSet/contact.png">
          <span slot="title">{{$t('account_set_3')}}</span>
        </el-menu-item>
        <el-menu-item v-if="isZnWebsite" index="1" route="/withdrawalAuto" class="home-page-wrap" v-bind:class="{ isActive: (thisPath === '/withdrawalAuto') }">
          <img class="menu-icon home-icon" src="../../assets/accountSet/contact.png">
          <span slot="title">{{$t('account_set_4')}}</span>
        </el-menu-item>
        <el-menu-item class="logout" index="8" @click="clickLogout">
          <!-- <img class="menu-icon home-icon" src="../../assets/menu/networkCbt.png"> -->
          <span slot="title">{{ $t('header.logout') }}</span>
        </el-menu-item>
        </el-menu>
      </el-col>
        

      <el-col :span="20" class="bonus-content">
        <div class="title first-title">
          <!-- title img -->
          <img v-if="thisPath === '/'" class="title-img" src="../../assets/menu/homeIconBlack.png"/>
          <img v-if="ifRevenueRouters" class="title-img" src="../../assets/menu/totalRevenueBlack.png"/>
          <img v-if="ifStatusRouters" class="title-img" src="../../assets/menu/networdBlack.png"/>
          <img v-if="ifWithdrawal" class="title-img" src="../../assets/menu/withdrawalBlack.png"/>
          <img v-if="ifnetContribution" class="title-img" src="../../assets/menu/networkCbtBlack.png"/>
          {{ pageTitle }}
        </div>
        <slot></slot>
      </el-col>
    </el-row>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { mapState, mapActions } from 'vuex';
const revenueRouters = ['/revenue', '/devAllRevenue', '/netDetail', '/calculateDetail', '/inviteDetail', '/devAllRevenue_new', '/devAllRevenue_old'];
const statusRouters = ['/deviceOverview', '/netStatus', '/calculateStatus', '/calculateTask','/standardDevErr'];
const otherRouters = ['/withdrawal', '/', '/networkContribution'];
import Footer from '@/components/Common/Footer.vue';
import { standardWatchDownlinkList } from '@/utils/watchDownlinkList.js';

export default {
  name: 'DatePanelLayout',
  props: {
    type: '',
    isRevenue: '',
    pageTitle: '',
    titleSrc: '',
  },
  components: {
    Header,
    Footer
  },
  data () {
    return {
      activeIndex: '0',
      revenueActive: true,
      showMenu: false,
      whichLanguage: false,
    }
  },
  computed: mapState({
    email: state => state.account.email,
    isZnWebsite: state => state.isZnWebsite,
    auth: state => state.buyBack.auth || '',
    thisPath () {
      return this.$route.path
    },
    // 是否datapanel路由
    ifDataPanel () {
      let thisPath = this.$route.path;
      return (revenueRouters.includes(thisPath) || statusRouters.includes(thisPath) || otherRouters.inclueds(thisPath));
    },
    // 是否Revenue路由
    ifRevenueRouters () {
      let thisPath = this.$route.path;
      return (revenueRouters.includes(thisPath));
    },
    // 是否status路由
    ifStatusRouters () {
      let thisPath = this.$route.path;
      return (statusRouters.includes(thisPath));
    },
    // 是否withdrawal路由
    ifWithdrawal () {
      let thisPath = this.$route.path;
      return thisPath === '/withdrawal'
    },
    // 是否京东卡路由
    ifExchange() {
      let thisPath = this.$route.path;
      return thisPath === '/exchange'
    },
    // 是否回购路由
    ifBuyback () {
      let thisPath = this.$route.path;
      return thisPath === '/buyback'
    },
    ifBuybackSecond () {
      let thisPath = this.$route.path;
      return thisPath === '/buyBackSecond'
    },
    // 是否networkContribution路由
    ifnetContribution () {
      let thisPath = this.$route.path;
      return thisPath === '/networkContribution';
    },
    // 是否展示监控（下行）路由
    isDownlinkUser() {
      return standardWatchDownlinkList.includes(this.email);
      // return true;
    },
    defaultOption () {
      let thisPath = this.$route.path
      if (revenueRouters.includes(thisPath)) {
        return ['1', '1-1', '1-1-6']
      } else if (statusRouters.includes(thisPath)) {
        return ['1', '1-2']
      }else if( thisPath === '/standardDevErr'){
        return ['1','1-3']
      }else if (thisPath === '/calculateStatus'
        || thisPath === '/calculateDetail') {
        return ['3']
      } else if (thisPath === '/dialStatus') {
        return ['6']
      } else if (
        thisPath === '/standardStatus' ||
        thisPath === '/standardWatch' ||
        thisPath === '/standardWatchDownlink' ||
        thisPath === '/standardDevErrnor' ||
        thisPath === '/standardAbnormalDisk' ||
        thisPath === '/standardBill' ||
        thisPath == '/standardAcceptance'
      ) {
        return ['9','9-3']
      } else if( thisPath === '/gapDetails' || thisPath === '/matchTask') {
        return ['10','10-1','10-2']
      }
    },
  }),
  created () {
    const body = document.getElementsByTagName('body')[0]
    body.classList.remove('overflow-hidden')

    // 缓存语言设置
    // let language = this.$cookie.get('NEW_BASIC_LANUAGE')
    this.$i18n.locale = this.isZnWebsite ? 'zn' : 'en';
    // this.whichLanguage = (language === 'zn');

    this.getBuyBackAuth();
  },
  methods: {
    toggleShowMenu () {
      this.showMenu = !this.showMenu
      const body = document.getElementsByTagName('body')[0]
      if (this.showMenu) {
        body.classList.add('overflow-hidden')
      } else {
        body.classList.remove('overflow-hidden')
      }
    },
    ...mapActions(['logout', 'getBuyBackAuth']),
    // 注销
    clickLogout () {
      this.logout()
    },
    // 语言切换
    // changeLanguage (locale) {
    //   this.whichLanguage = (locale === 'zn')
    //   this.$i18n.locale = locale
    //   this.$cookie.set('NEW_BASIC_LANUAGE', locale)
    //   window.location.reload()
    // },
  },
  watch: {
    '$route' () {
      console.log('show menu change')
    }
  }
}
</script>

<style lang="stylus">
.is-mobile {
  .menu {
    display none
    position: fixed;
    right 0
    width: 220px;
    z-index: 10;
    height: calc(100% - 62px);
    overflow-y: auto;
    background: #0a0f22;
    &.show {
      display block
    }
    .panel-wrap {
      opacity 1
    }
  }
  .bonus-content {
    padding 0
    width 100%
    min-height 0
    overflow: auto;
    .first-title {
      display none
    }
  }
  .annouce .title {
    padding-left 15px
    padding-right 15px
  }
  .annouce-content {
    margin-right 15px
    margin-left 15px
  }
  .date-panel-layout {
    /deep/ .home-header {
      margin 0
      width 100%
      overflow hidden
      .header-panel {
        .exit, .lang {
          position relative
          left 0
          right 0
        }
        &:before, &:after {
          display none
        }
      }
      .header-login-panel {
        width auto
      }
    }
  }
  .layer {
    position fixed
    width 100%
    height 100%
    z-index 9
    background: rgba(0, 0, 0, 0.5);
  }
  .FAQ {
    display none
  }
  .list-tab {
    margin-right 0
    margin-left 0
  }
  .logout, .menu-item-wrapper {
    display block
  }
  .header-language {
    position relative
    right 0
  }
}

.logout, .menu-item-wrapper {
  display none
}

.revenue-wrap .revenuePad {
  padding-left: 20px;
}

.revenue-wrap .el-submenu__title {
  padding-left: 0 !important;
}

.content-wrap {
  display: flex;
  justify-content: flex-start;
}

.menu-detail {
  width: 168px;
}

.panel-wrap {
  padding-left: 25px;
  text-align: left;
  height: 40px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  line-height: 40px;
  opacity: 0.5;
  background: #0A0F22;
  line-height: 40px;
  color: #fff;
}

.home-panel {
  height: 45px;
  line-height: 45px;
  background: #032031;
  position: relative;
}

.home-panel-border {
  position: absolute;
  left: 0;
  top: 0;
  position: absolute;
  left: 0;
  top: 0;
  background-image: linear-gradient(-180deg, #15BCAD 2%, #10B2CB 100%);
  width: 4px;
  height: 100%;
}

.home-panel-text {
  padding: 0 20px;
  color: #fff;
  font-size: 12px;
  line-height: 45px;
  display: flex;
  vertical-align: middle;
}

.home-icon {
  display: inline-block;
  margin-top: 15px;
  width: 15px;
  height: 15px;
}

.menu-panel {
  width: 168px;
  background: #000519;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}

.bonus-menu .el-menu-item {
  height: 45px;
  line-height: 45px;
  font-size: 15px;
  text-align: left;
}

.bonus-menu .el-submenu__title {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  text-align: left;
}

.detail-wrap {
  width: 100%;
}

.title-img {
  width: 12px;
  height: 12px;
  margin-right: 5px;
}

.el-alert__title {
  font-size: 10px;
}

.home .el-menu {
  border-right: 0px;
}

.menu-icon {
  margin: -2px 8px 0 0;
  width: 12px;
  height: 12px;
}

.isActive, .el-menu-item.is-active {
  background-color: #032031;
  border-left: 3px solid #11B6BD;
  color: #fff !important;
}

.bonus-content {
  background: #F6F6F7;
  // height: 100%;
  padding: 0 35px 35px;
}

.bonus-content {
  font-family: PingFangSC-Medium;
}

.bonus-content .title {
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #65686A;
  line-height: 45px;
  text-align: left;
  font-weight: bold;
}

.annouce {
  background: #FFFFFF;
  border: 1px solid #E3E3E7;
  position: relative;
}

.annouce .more {
  font-size: 14px;
  color: #999B98;
  text-align: right;
  line-height: 40px;
  position: absolute;
  right: 30px;
  top: 0;
}

.annouce .title {
  padding: 0 30px;
  font-size: 14px;
  color: #343739;
  line-height: 40px;
  border-bottom: 1px solid #E7EAEC;
}

.bonus-menu .el-submenu .el-menu-item {
  min-width: 20px;
}

.annouce-content {
  margin: 0 23px;
}

.header-language {
  position: absolute;
  right: 100px;
  text-align: center;
  width: 40px
}

</style>
